import { EditableBlock } from './EditableBlock';
import { TextboxContainer, TextboxViewport } from './styles';
import { PageControls } from '../PageControls';
import { AiTools } from '../AiTools';
import { useStore } from '../../../store';
import { AudioTrack } from '../AudioTrack';
import { useContext, useRef } from 'react';
import { TtsContext } from '../../../contexts/TtsContext';
import { Toolbox } from '../Toolbox';
import { useTranslation } from 'react-i18next';

interface EditablePageProps {
  isTrial: boolean;
}

export const EditablePage = ({ isTrial }: EditablePageProps) => {
  const { blocks } = useStore();

  const { t } = useTranslation('myapps');

  const audioTrackRef = useRef<HTMLAudioElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  const { isToolboxVisible, toolboxOptions } = useContext(TtsContext);

  return (
    <TextboxContainer ref={containerRef}>
      <div className="fixedControls" id="tts_step_1">
        <h2>{t('TTS_PAGE_TITLE')}</h2>

        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '1rem',
          }}
        >
          <AudioTrack ref={audioTrackRef} />
          <PageControls />
        </div>
      </div>
      <TextboxViewport onDragStartCapture={(ev) => ev.preventDefault()}>
        <AiTools />
        {blocks.map((block, key) => (
          <EditableBlock
            key={key}
            id={block.id}
            index={key}
            block={block}
            audioRef={audioTrackRef}
          />
        ))}
      </TextboxViewport>
      {isToolboxVisible && toolboxOptions && (
        <div
          style={{
            position: 'absolute',
            top:
              toolboxOptions.position.top -
              (containerRef.current?.getBoundingClientRect().top || 0),
            left:
              toolboxOptions.position.left -
              (containerRef.current?.getBoundingClientRect().left || 0),
            zIndex: 9999,
          }}
        >
          <Toolbox
            blockId={toolboxOptions.id}
            range={toolboxOptions.selection}
            selectionId={toolboxOptions.selectionId ?? ''}
            openSpeakerModal={() => toolboxOptions.openModalAction()}
          />
        </div>
      )}
    </TextboxContainer>
  );
};
